import ReactGA from 'react-ga4';

export const initGA = (measurementId) => {
  if (!measurementId) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('GA skipped: REACT_APP_GA_MEASUREMENT_ID is not set');
    }
    return;
  }

  ReactGA.initialize(measurementId);
  ReactGA.initialize('G-BVF8JKZ26L', { testMode: false });
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

export const logEvent = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
}; 